import React from 'react';
import Alpha from '../color-alpha';
import { PointerProps } from '../color-alpha/Pointer';
import Hue from '../color-hue';
import { HsvaColor, hsvaToHexa } from '../utils/color-convert';
import EyeDropper from './eye-dropper';

export const Bar = (props: PointerProps) => (
    <div
        style={{
            boxShadow: 'rgb(0 0 0 / 60%) 0px 0px 2px',
            width: 14,
            height: 14,
            top: -1,
            left: props.left,
            border: '2px solid rgba(255, 255, 255,1)',
            borderRadius: '50%',
            position: 'absolute',
            backgroundColor: (props.hsva && hsvaToHexa(props.hsva)) || '#ffffff',
        }}
    />
);

// 颜色预览
export const SelectPreview = ({ hsva }: { hsva: HsvaColor }) => {
    return (
        <div className="c-color-sketch-picker__tool--preview">
            <div style={{ background: hsvaToHexa({ ...hsva, a: 1 }) }}></div>
            <div style={{ background: hsvaToHexa(hsva) }}></div>
        </div>
    );
};

// 颜色滑块组
const ColorSliderGroup = ({
    hsva,
    hideAlpha,
    handleChange,
}: {
    hsva: HsvaColor;
    hideAlpha: boolean;
    handleChange: (hsva: HsvaColor) => void;
}) => {
    return (
        <div className="c-color-sketch-picker__tool--setting">
            <Hue
                width="auto"
                height={12}
                hsva={{ ...hsva, a: 1 }}
                pointer={Bar}
                innerProps={{
                    style: { marginLeft: 0, marginRight: 10 },
                }}
                radius={6}
                // 如果透明度为0，设置颜色, 需要变成1
                onChange={(newHue) => handleChange({ ...newHue, a: hsva.a === 0 ? 1 : hsva.a })}
            />
            {!hideAlpha && (
                <Alpha
                    width="auto"
                    height={12}
                    hsva={hsva}
                    pointer={Bar}
                    style={{ marginTop: 8 }}
                    innerProps={{
                        style: { marginLeft: 0, marginRight: 10 },
                    }}
                    radius={6}
                    onChange={(newAlpha) => {
                        handleChange({ ...hsva, ...{ a: newAlpha.a } });
                    }}
                />
            )}
        </div>
    );
};

type Props = {
    useRGBAInput?: boolean;
    hsva: HsvaColor;
    hideAlpha: boolean;
    hasEyeDropper: boolean;
    handleChange: (hsva: HsvaColor) => void;
    setHex: (hex: string) => void;
    setHsva: (hsva: HsvaColor) => void;
};

const ToolGroup = ({ hsva, hideAlpha, handleChange, useRGBAInput, hasEyeDropper, setHex, setHsva }: Props) => {
    if (useRGBAInput) {
        return (
            <div className="c-color-sketch-picker__tool input_RGBA">
                {hasEyeDropper && <EyeDropper setHex={setHex} setHsva={setHsva} handleChange={handleChange} />}
                <ColorSliderGroup hsva={hsva} hideAlpha={hideAlpha} handleChange={handleChange} />
                <SelectPreview hsva={hsva} />
            </div>
        );
    }

    return (
        <div className="c-color-sketch-picker__tool">
            <SelectPreview hsva={hsva} />
            <ColorSliderGroup hsva={hsva} hideAlpha={hideAlpha} handleChange={handleChange} />
        </div>
    );
};

export default ToolGroup;
